'use strict'

replacements = {}
regexp = ''

escapeRegExp = (str) ->
  str.replace /([-.*+?^=!:${}()|[\]\/\\])/g, '\\$1'

initRegExp = (charMap) ->
  reg = ''
  invertedMap = Object.entries(charMap).reduce (collection, [key, val]) ->
    reg += val
    for char in val
      collection[char] = key
    collection
  , {}

  {
    regexp: new RegExp '[' + escapeRegExp(reg) + ']', 'g'
    replacements: invertedMap
  }

normalizeQuery = (s) ->
  return '' if typeof s isnt 'string'

  if not (regexp)
    # stems from config/header_character_mapping.json -> exposed in the HTML body
    charMap = window.Groupon.LS.data.charMapping or {}
    { regexp, replacements } = initRegExp(charMap)

  s = s.trim().replace regexp, (c) -> replacements[c]
  s.toLowerCase()

module.exports = {
  initRegExp
  escapeRegExp
  normalizeQuery
}



// WEBPACK FOOTER //
// ./src/frontend/helper/search/helper/m_normalizeQuery.coffee